import { render } from "./DdCard.vue?vue&type=template&id=dd50e5a0"
import script from "./DdCard.vue?vue&type=script&lang=js"
export * from "./DdCard.vue?vue&type=script&lang=js"

import "./DdCard.vue?vue&type=style&index=0&id=dd50e5a0&lang=less"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__